import { createSelector } from 'reselect';
import { List, Map } from 'immutable';
import get from 'lodash/get';

import Brand from 'models/brand';
import { PressRelease } from 'models/press-release';

const readProp = (slice, key, defaultValue) => {
  if (!slice) {
    return defaultValue;
  }
  if (typeof slice.get === 'function') {
    const val = slice.get(key);
    return val !== undefined ? val : defaultValue;
  }
  return get(slice, key, defaultValue);
};

export const getBrandState = state => get(state, 'brand', null);

export const getBrand = createSelector(
  [getBrandState],
  (brandState) => {
    if (brandState instanceof Brand) {
      return brandState;
    }
    return readProp(brandState, 'brand', new Brand());
  },
);

export const getBrandName = createSelector(
  [getBrand],
  brand => readProp(brand, 'displayName', '') || readProp(brand, 'name', ''),
);

export const getBrandDiff = createSelector(
  [getBrandState],
  brandState => readProp(brandState, 'brandDiff', Map()),
);

export const getRoutingStyle = createSelector(
  [getBrand],
  brand => readProp(brand, 'routingStyle', null),
);

export const getHomePageInitialized = createSelector(
  [getBrandState],
  brandState => Boolean(readProp(brandState, 'homePageInitialized', false)),
);

export const getBusinessPageInitialized = createSelector(
  [getBrandState],
  brandState => Boolean(readProp(brandState, 'businessPageInitialized', false)),
);

export const getHowItWorksInitialized = createSelector(
  [getBrandState],
  brandState => Boolean(readProp(brandState, 'howItWorksInitialized', false)),
);

export const getOurAppsPageInitialized = createSelector(
  [getBrandState],
  brandState => Boolean(readProp(brandState, 'ourAppsPageInitialized', false)),
);

export const getOAuthPageInitialized = createSelector(
  [getBrandState],
  brandState => Boolean(readProp(brandState, 'oAuthPageInitialized', false)),
);

export const getAnnouncementBannerDismissed = createSelector(
  [getBrandState],
  brandState => Boolean(readProp(brandState, 'announcementBannerDismissed', false)),
);

export const getPartnerModalDismissed = createSelector(
  [getBrandState],
  brandState => Boolean(readProp(brandState, 'partnerModalDismissed', false)),
);

export const getAffiliateTerms = createSelector(
  [getBrandState],
  brandState => readProp(brandState, 'affiliateTerms', ''),
);

export const getExecBiographies = createSelector(
  [getBrandState],
  brandState => readProp(brandState, 'execBiographies', List()),
);

export const getPressArticles = createSelector(
  [getBrandState],
  brandState => readProp(brandState, 'pressArticles', List()),
);

export const getPressReleases = createSelector(
  [getBrandState],
  brandState => readProp(brandState, 'pressReleases', List()),
);

export const getPressRelease = createSelector(
  [getBrandState],
  brandState => readProp(brandState, 'pressRelease', new PressRelease()),
);
